import React, { useCallback, useEffect, useState } from 'react';
import * as Styled from './MutedNotification.styled';
import { Icon } from '@virtidev/toolbox';
import { useMounted } from '../../../utility/StateHooks';
import useMicStreamVolume from '../../../../../core/src/components/MicrophoneStreamProvider/useMicStreamVolume';

const MutedNotification = ({ active, showMutedNoticeIfTalked }) => {
  const [mutedNoticeActive, setMutedNoticeActive] = useState(false);
  const mounted = useMounted();
  const volume = useMicStreamVolume(40, active);
  const [hasShown, setHasShown] = useState(false);

  const hideNotice = useCallback(() => {
    const timer = setTimeout(() => {
      console.log('timer timed out');
      if (mounted.current) {
        setMutedNoticeActive(false);
      }
    }, 1000);
    return timer;
  }, [setMutedNoticeActive, mounted]);

  // show muted notice if volume high enough
  useEffect(() => {
    if (!showMutedNoticeIfTalked) return;
    if (volume > 0.2 && !hasShown) {
      setHasShown(true);
      setMutedNoticeActive(true);
    }
  }, [volume, hideNotice, showMutedNoticeIfTalked, mounted, hasShown]);

  // if muted notice becomes active, set a timer to hide it
  useEffect(() => {
    let timer;
    if (mutedNoticeActive) {
      console.log('start timer');
      timer = setTimeout(() => {
        console.log('timer timed out');
        if (mounted.current) {
          setMutedNoticeActive(false);
        }
      }, 4000);
    }
    return () => {
      if (timer) {
        console.log('clear timer');
        clearTimeout(timer);
      }
    };
  }, [mutedNoticeActive, mounted]);

  useEffect(() => {
    if (active) {
      setMutedNoticeActive(false);
    }
  }, [active]);

  return (
    <>
      {mutedNoticeActive && (
        <Styled.MutedMessage>
          <Icon size="1.5rem" icon="microphone" type="solid" />
          <div>Click the microphone button to start recording</div>
        </Styled.MutedMessage>
      )}
    </>
  );
};

export default MutedNotification;
